<template>
    <div class="flex flex-col mt-5">
        <div>
            <button
                type="button"
                @click="showCreateForm = !showCreateForm"
                class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg
                    class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </button>
        </div>
        <SlideOver :show="showCreateForm" @close="showCreateForm = false">
            <form action="" @submit.prevent="addLink()">
                <div>
                    {{ $t('messages.title') }}
                </div>
                <input
                    type="text"
                    v-model.trim="form.title"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <div>
                    {{ $t('messages.url') }}
                </div>
                <input
                    type="text"
                    required
                    v-model.trim="form.url"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <input
                    type="hidden"
                    v-model="form.id"
                    class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <AppButton desired-action element="button" type="submit" class="mt-3">
                    {{ $t('messages.add') }}
                </AppButton>
            </form>
        </SlideOver>
        <SlideOver :show="showEditForm !== false" @close="closeEditForm()">
            <div v-if="editLink">
                <div>
                    {{ $t('messages.title') }}
                </div>
                <input
                    type="text"
                    v-model.trim="editLink.title"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <div>
                    {{ $t('messages.url') }}
                </div>
                <input
                    type="text"
                    required
                    v-model.trim="editLink.url"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <AppButton desired-action element="button" type="button" @click="closeEditForm()" class="mt-3">
                    {{ $t('messages.close') }}
                </AppButton>
            </div>
        </SlideOver>

        <ul class="">
            <li v-for="(row, index) in rows" :key="index" class="flex space-x-1">
                <a :href="row.url" target="_blank" class="text-indigo-500">
                    <svg
                        class="w-4 h-4 inline-block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                        ></path>
                        <path
                            d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                        ></path>
                    </svg>

                    <span class="truncate text-ellipsis overflow-hidden">
                        {{ row.title ? row.title : row.url }}
                    </span>
                </a>
                <input
                    type="hidden"
                    :name="`links[${index}][title]`"
                    v-model.trim="row.title"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />
                <input
                    type="hidden"
                    :name="`links[${index}][url]`"
                    required
                    v-model.trim="row.url"
                    class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />
                <input
                    type="hidden"
                    :name="`links[${index}][id]`"
                    required
                    v-model="row.id"
                    class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />
                <button
                    type="button"
                    @click="edit(row)"
                    class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                        ></path>
                    </svg>
                </button>
                <button
                    type="button"
                    @click="deleteRow(index)"
                    class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                        <path
                            fill-rule="evenodd"
                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </button>
            </li>
        </ul>
        <input type="hidden" v-for="id in links_to_delete" name="links_to_delete[]" :value="id" />
    </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['update:modelValue'],
    components: {
        AppButton,
        SlideOver,
    },
    data() {
        return {
            rows: this.modelValue,
            editLink: null,
            links_to_delete: [],
            showCreateForm: false,
            showEditForm: false,
            form: {
                id: null,
                title: '',
                url: '',
            },
        };
    },
    props: {
        linksInput: {
            type: Array,
            required: false,
            default: () => [],
        },
        modelValue: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    watch: {
        rows(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        modelValue(newVal) {
            this.rows = newVal;
        },
    },
    methods: {
        edit(row) {
            this.editLink = row;
            this.showEditForm = true;
        },
        closeEditForm() {
            this.showEditForm = false;
            this.editLink = null;
        },
        addRow() {
            this.rows.push({
                id: null,
                title: '',
                url: '',
            });
        },
        addLink() {
            this.rows.push({
                id: this.form.id,
                title: this.form.title,
                url: this.form.url,
            });

            this.form = {
                id: null,
                title: '',
                url: '',
            };

            this.showCreateForm = false;
        },
        deleteRow(index) {
            const link = this.rows[index];
            if (link.id !== null) {
                this.links_to_delete.push(link.id);
            }

            this.rows.splice(index, 1);
        },
    },
    mounted() {
        if (this.linksInput.length) {
            this.rows = this.linksInput;
        }
    },
};
</script>
